export default class RiskFactorCriteria {
  criteriaID = null

  riskFactor = null

  riskFactorCode = null

  clinicianRiskFactor = null
}
